import { render } from "./ApprovalsListCardDetails.vue?vue&type=template&id=37d4bd2e"
import script from "./ApprovalsListCardDetails.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__